import React from "react"
import { image } from "../../assets/images"
import { FooterWrapp } from "./Footer.style"

const Footer = () => {
  return (
    <FooterWrapp>
      <div className="footer">
        <div className="container">
          <div className="content-footer">
            <div className="about">
              <div className="logo">
                <img src={image.logo} alt="" />
                <h1>KarirKu</h1>
              </div>
              <p>An internship search platform tailored to your skills and interests</p>
              <div className="logos">
                <img src={image.icon_instagram} alt="icon-instagram" />
                <img src={image.icon_linkedin} alt="icon-linkedin" />
                <p className="text">KarirKu</p>
              </div>
            </div>
            <div className="navigation">
              <h1>Navigation</h1>
              <ul>
                <li> <a href="/">Career Recommendation</a></li>
                <li> <a href="/">Internships</a></li>
              </ul>
            </div>
            <div className="address">
              <h1>Address</h1>
              <p>Jalan Srijaya Negara, Lorong Jaya Sampurna No. 22, Bukit Lama, Palembang</p>
            </div>
          </div>
          <h1 className="copyright"> &copy; 2022 Copyright KarirKu</h1>
        </div>
      </div>
    </FooterWrapp>
  )
}

export default Footer
